


import { Modal, ModalHeader, ModalBody, Input, Table, Button } from "reactstrap";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNavBlock } from "helperFunctions/GuardNavigation";
import { useRecipientsList, useSendInfo } from "Api/Common/CommonComponents";
import moment from "moment";

const InformationModel = ({ emailSmsRecipients, getRequests, isOpen, setIsInformationModalOpen, substitutionId, coordinatorName, statusCount, setStatusCount, recipientsLists }) => {
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false)
    const [emailToSend, setEmailToSend] = useState([]);
    const [smsToSend, setSmsToSend] = useState([]);
    const [startPolling, setStartPolling] = useState(false);

    const { trigger: sendInfo, isMutating: isSending } = useSendInfo();
    const { pendingNavigation, proceedNavigation, cancelNavigation, setHasSelectedEmail } = useNavBlock();

    const { data: recipientsListData } = useRecipientsList({
        substitutionId,
        polling: startPolling,
    });

    useEffect(() => {
        const defaultEmailToSend = () => {
            setEmailToSend(() => recipientsLists?.vervanger?.filter(user =>
                emailSmsRecipients?.some(item =>
                    item?.id === user?.id
                )
            ).map(user => ({
                id: user.id,
                userType: "vervanger"
            })) || [])
        }

        defaultEmailToSend();
    }, [emailSmsRecipients])

    useEffect(() => {
        checkedEmails();
    }, [smsToSend?.length, emailToSend]);

    useEffect(() => {
        setHasSelectedEmail(emailToSend.length > 0);
    }, [emailToSend, setHasSelectedEmail]);


    const checkedEmails = () => {
        const combinedResult = [...emailToSend, ...smsToSend];

        const uniqueSet = new Set(
            combinedResult.map((item) => JSON.stringify({ id: item.id, userType: item.userType }))
        );
        const finalResult = Array.from(uniqueSet).map((item) => JSON.parse(item));

        setStatusCount(finalResult.length);
    }

    const handleSmsCheckboxChange = (id, userType) => {
        const index = smsToSend?.findIndex(
            (item) => (item.id === id && item.userType === userType)
        );

        const defaultMsg = userType === "vervanger" ? `Beste vervanger, Verzoek ${substitutionId} ${coordinatorName}` : userType === "melder" ? `Beste melder, Verzoek ${substitutionId} ${coordinatorName}` : `Beste user, Verzoek ${substitutionId} ${coordinatorName}`

        if (index === -1) {
            setSmsToSend([...smsToSend, { id, userType, message: defaultMsg }]);
        } else {
            const newCheckedIds = smsToSend?.filter(item => !(item.id === id && item.userType === userType));
            setSmsToSend(newCheckedIds);
        }
    };

    const handleEmailCheckboxChange = (id, userType) => {
        const index = emailToSend?.findIndex(
            (item) => item.id === id && item.userType === userType
        );
        if (index === -1) {
            setEmailToSend([...emailToSend, { id, userType }]);
        } else {
            const newCheckedIds = emailToSend?.filter(item => !(item.id === id && item.userType === userType));
            setEmailToSend(newCheckedIds);
        }
    };

    const handleSmsTextChange = (e, id, userType) => {
        const value = e.target.value;
        setSmsToSend((prev) => {
            return prev.map((item) => {
                if (item.id === id && item.userType === userType) {
                    return { ...item, message: value };
                } else {
                    return item;
                }
            });
        });
    };


    const handleSubmit = () => {
        setDisableSubmitBtn(true);
        const substSms = smsToSend.map((item) => ({
            ...item,
            iCredits: Math.max(1, Math.ceil((item.message?.length || 0) / 160)),
            iChar: item.message?.length || 0
        }));
        const dataToSend = { substEmail: emailToSend, substSms, iSubstitutionId: substitutionId };
        sendInfo({
            method: "post",
            data: dataToSend
        }).then((response) => {
            if (response.status === true) {
                setIsInformationModalOpen(false);
                setStatusCount(0)
                setEmailToSend([]);
                setSmsToSend([]);
                setHasSelectedEmail(false);
                setStartPolling(true);

                setTimeout(() => {
                    setStartPolling(false);
                }, 60000);
                setTimeout(() => {
                    getRequests();

                    if (pendingNavigation) {
                        proceedNavigation();
                    } else {
                        setIsInformationModalOpen(false);
                    }
                }, 3000);


            }
        })
            .catch((error) => console.log("Error:", error))
            .finally(() => setDisableSubmitBtn(false));

    };

    const doesUserExist = (array, id, userType) => {
        return array?.findIndex((item) => item.id === id && item.userType === userType) !== -1;
    };

    const getMessageByIdAndUserType = (array, id, userType) => {
        const foundItem = array?.find((item) => item.id === id && item.userType === userType);
        return foundItem ? foundItem.message : "";
    };

    const getMsgCount = (id, userType) => {
        const userSms = smsToSend?.filter(item => item.id === id && item.userType === userType)
        const message = userSms?.length === 0 ? "" : userSms[0]?.message
        const smsCount = Math.ceil((message?.length + 1) / 160);
        return smsCount || 1
    }

    const handleClose = () => {

        if (pendingNavigation) {
            proceedNavigation();
        } else {
            setIsInformationModalOpen(false);
        }
    };
    const message =
        getMessageByIdAndUserType(
            smsToSend,
            recipientsLists?.melder?.id,
            "melder"
        ) || "";

    const remainingChars = 1377 - message.length;




    return (
        <Modal id={"tooltip"} isOpen={isOpen} toggle={handleClose} className="modal-dialog__over feedback-modal-style opmerking-modal-styling info-modal-width">
            <ModalHeader >
                <div className="modal-header-styling" >
                    Informeren ({statusCount})
                </div>
                <div className="cross-icon-color">
                    <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={handleClose}> </i>
                </div>
            </ModalHeader>

            <ModalBody className="bg-white rounded">

                <div style={{ display: "flex", gap: "30px", alignItems: "flex-start" }}>
                    <div style={{ flex: 1 }}>
                        <Table
                            borderless
                            className="info-modal-table-row"
                            style={{ marginBottom: "0px", borderCollapse: "collapse" }}
                        >
                            <thead>
                                <tr className="info-modal-table-head">
                                    <th>Melder</th>
                                    <th>E-mail</th>
                                    <th >SMS</th>
                                    <th style={{ width: "195px" }}>Laatst verzonden e-mail</th>
                                </tr>
                            </thead>

                            <tbody className="border info-modal-table-row">
                                <tr className="info-modal-table-row">
                                    <td className=" info-data-padding" style={{ width: "38%" }}>
                                        {recipientsLists?.melder?.name}
                                    </td>


                                    <td className="info-data-padding" >
                                        <Input
                                            className="info-modal-table-checkbox checked-checkbox"
                                            type="checkbox"
                                            onChange={() =>
                                                handleEmailCheckboxChange(
                                                    recipientsLists?.melder?.id,
                                                    "melder"
                                                )
                                            }
                                            checked={doesUserExist(
                                                emailToSend,
                                                recipientsLists?.melder?.id,
                                                "melder"
                                            )}
                                        />
                                    </td>

                                    <td className="info-data-padding borderRight " >
                                        <Input
                                            className="info-modal-table-checkbox checked-checkbox"
                                            type="checkbox"
                                            onChange={() =>
                                                handleSmsCheckboxChange(
                                                    recipientsLists?.melder?.id,
                                                    "melder"
                                                )
                                            }
                                            checked={doesUserExist(
                                                smsToSend,
                                                recipientsLists?.melder?.id,
                                                "melder"
                                            )}
                                        />
                                    </td>

                                    <td
                                        style={{
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            padding: "5px 0.5rem",
                                            borderRight: "1px solid #D0DFE7",
                                        }}
                                    >
                                        {
                                            (recipientsListData?.recipientsList?.original?.melder?.sentAt ||
                                                recipientsLists?.melder?.sentAt)
                                                ? moment(
                                                    recipientsListData?.recipientsList?.original?.melder?.sentAt ||
                                                    recipientsLists?.melder?.sentAt,
                                                    "DD-MM-YYYY HH:mm"
                                                ).format("DD-MM-YY - HH:mm")
                                                : "-"
                                        }
                                    </td>
                                </tr>

                                {doesUserExist(
                                    smsToSend,
                                    recipientsLists?.melder?.id,
                                    "melder"
                                ) && (
                                        <>
                                            <tr>
                                                <td colSpan={3} className="borderRight">SMS verzenden</td>
                                            </tr>

                                            <tr>
                                                <td colSpan={3} className="borderRight">
                                                    <textarea
                                                        type="text"
                                                        className="info-modal-input"
                                                        maxLength={1377}
                                                        value={getMessageByIdAndUserType(
                                                            smsToSend,
                                                            recipientsLists?.melder?.id,
                                                            "melder"
                                                        )}
                                                        onChange={(e) =>
                                                            handleSmsTextChange(
                                                                e,
                                                                recipientsLists?.melder?.id,
                                                                "melder"
                                                            )
                                                        }
                                                    />

                                                </td>
                                            </tr>

                                            <tr >
                                                <td colSpan={3} className="p-0 borderRight">
                                                    <div className="info-modal-text ps-1">
                                                        Totaal aantal karakters over {remainingChars} - Aantal berichten:{" "}
                                                        {getMsgCount(
                                                            recipientsLists?.melder?.id,
                                                            "melder"
                                                        ) || 1}
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )}
                            </tbody>
                        </Table>
                    </div>
                </div>


                <div
                    className="table-container"
                    style={{ display: "flex", gap: "30px", alignItems: "flex-start" }}
                >
                    <div style={{ flex: 1 }}>
                        <Table
                            borderless
                            className="mb-0 info-modal-table-row"
                            style={{ marginBottom: "0px", borderCollapse: "collapse" }}
                        >
                            <thead>
                                <tr className="info-modal-table-head">
                                    <th style={{ width: "38%" }} >Vervanger</th>
                                    <th>E-mail</th>
                                    <th >SMS</th>
                                    <th style={{ width: "195px" }}>&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody className="border info-modal-table-row">
                                {recipientsLists?.vervanger?.map((element) => (
                                    <React.Fragment key={element.id}>
                                        <tr
                                            className={
                                                !doesUserExist(smsToSend, element.id, "vervanger")
                                                    ? "border-bottom"
                                                    : ""
                                            }
                                        >
                                            <td className=" info-data-padding" style={{ width: "38%" }} >
                                                {element.name}
                                            </td>

                                            <td className="info-data-padding">
                                                <Input
                                                    className="info-modal-table-checkbox checked-checkbox"
                                                    type="checkbox"
                                                    onChange={() =>
                                                        handleEmailCheckboxChange(
                                                            element.id,
                                                            "vervanger"
                                                        )
                                                    }
                                                    checked={doesUserExist(
                                                        emailToSend,
                                                        element.id,
                                                        "vervanger"
                                                    )}
                                                />
                                            </td>

                                            <td className="info-data-padding borderRight" >
                                                <Input
                                                    className="info-modal-table-checkbox checked-checkbox"
                                                    type="checkbox"
                                                    onChange={() =>
                                                        handleSmsCheckboxChange(
                                                            element.id,
                                                            "vervanger"
                                                        )
                                                    }
                                                    checked={doesUserExist(
                                                        smsToSend,
                                                        element.id,
                                                        "vervanger"
                                                    )}
                                                />
                                            </td>

                                            <td
                                                style={{
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    padding: "5px 0.5rem",

                                                    borderTop: "1px solid #D0DFE7",
                                                    borderBottom: !doesUserExist(
                                                        smsToSend,
                                                        element.id,
                                                        "vervanger"
                                                    )
                                                        ? "1px solid #D0DFE7"
                                                        : "",
                                                }}
                                            >
                                                {
                                                    (() => {
                                                        const pollingUser =
                                                            recipientsListData?.recipientsList?.original?.vervanger?.find(
                                                                user => user.id === element.id
                                                            );

                                                        const oldUser =
                                                            recipientsLists?.vervanger?.find(
                                                                user => user.id === element.id
                                                            );

                                                        const sentAt = pollingUser?.sentAt || oldUser?.sentAt;

                                                        return sentAt
                                                            ? moment(sentAt, "DD-MM-YYYY HH:mm")
                                                                .format("DD-MM-YY - HH:mm")
                                                            : "-";
                                                    })()
                                                }
                                            </td>
                                        </tr>

                                        {doesUserExist(
                                            smsToSend,
                                            element.id,
                                            "vervanger"
                                        ) && (
                                                <>
                                                    <tr>
                                                        <td colSpan={3} className="borderRight">SMS verzenden</td>

                                                    </tr>

                                                    <tr>
                                                        <td colSpan={3} className="borderRight" >
                                                            <textarea
                                                                type="text"
                                                                className="info-modal-input"
                                                                maxLength={1377}
                                                                value={getMessageByIdAndUserType(
                                                                    smsToSend,
                                                                    element.id,
                                                                    "vervanger"
                                                                )}
                                                                onChange={(e) =>
                                                                    handleSmsTextChange(
                                                                        e,
                                                                        element.id,
                                                                        "vervanger"
                                                                    )
                                                                }
                                                            />

                                                        </td>
                                                    </tr>

                                                    <tr >
                                                        <td
                                                            colSpan={3}
                                                            style={{
                                                                borderRight: "1px solid #D0DFE7",
                                                                borderBottom:
                                                                    "1px solid #D0DFE7",

                                                            }}
                                                        >
                                                            <div className="info-modal-text ps-1">
                                                                Totaal aantal karakters over{" "}
                                                                {1377 -
                                                                    (
                                                                        getMessageByIdAndUserType(
                                                                            smsToSend,
                                                                            element.id,
                                                                            "vervanger"
                                                                        ) || ""
                                                                    ).length}{" "}
                                                                - Aantal berichten: {getMsgCount(element.id, "vervanger") || 1}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>



                <div className="request-modal-footer">
                    <Button
                        className="d-flex align-items-center btn-color-style opslaan-btn btn btn-outline-primary btn-sm info-btn-padding"
                        size="sm"
                        outline
                        color="primary"
                        type="submit"
                        onClick={() => handleSubmit()}
                        disabled={disableSubmitBtn}
                    >
                        Verzenden
                    </Button>
                    <Button
                        className="d-flex align-items-center btn-color-style opslaan-btn btn btn-outline-primary btn-sm info-btn-padding"
                        size="sm"
                        outline
                        color="primary"
                        onClick={handleClose}
                    >
                        Terug
                    </Button>
                </div>

            </ModalBody>
        </Modal >
    );
}

export default InformationModel;